/**
 * Маркетинговый формат игры для витрин каталога. Движок у всех квестов один —
 * это лишь способ назвать его словом, привычным рынку (scavenger hunt,
 * walking tour, ghost tour), как это делает Questo.
 */
export enum CityQuestDisplayTypeEnum {
    SCAVENGER_HUNT = 'scavenger_hunt',
    WALKING_TOUR = 'walking_tour',
    GHOST_TOUR = 'ghost_tour',
}
